<template>
  <div class="agreement-page">
    <Mytitle :use-background="false" :text-color="'black'" :padding="'20px 11%'" />
    <div class="container">
      <h1>用户协议</h1>
      <div class="content">
        <p>欢迎使用本报名系统。为保障您的权益，请在使用前仔细阅读并同意本用户协议。</p>
        <h2>账号与信息</h2>
        <p>您需保证所提交的信息真实、准确、完整。因信息不实造成的后果由您自行承担。</p>
        <h2>隐私与数据</h2>
        <p>系统按照法律法规与业务需要收集、使用与保存数据，并采取合理措施保护您的隐私与数据安全。</p>
        <h2>使用规范</h2>
        <p>不得利用系统进行任何违法违规或侵害他人合法权益的行为，不得进行破坏性测试或绕过安全机制。</p>
        <h2>服务与变更</h2>
        <p>系统可能根据政策与实际情况调整功能与服务内容，更新将以公告或页面提示的方式通知。</p>
        <h2>免责与责任</h2>
        <p>因不可抗力或第三方原因导致的服务中断或数据损失，系统不承担相应责任，但将尽力恢复服务。</p>
        <h2>联系方式</h2>
        <p>如有问题或建议，可通过页面提供的联系方式与我们沟通。</p>
      </div>
      <div class="actions">
        <button class="btn" @click="back">返回</button>
      </div>
    </div>
  </div>
  </template>
  <script>
  import Mytitle from '../assets/title.vue'
  export default {
    name: 'UserAgreement',
    components: { Mytitle },
    emits: ['back'],
    methods: {
      back() {
        const from = (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('last_page')) || '#register'
        const h = (from || '#register').replace('#','')
        try { window.location.hash = h } catch (e) {}
        this.$emit('back')
      }
    }
  }
  </script>
  <style scoped>
  .agreement-page { width: 100%; }
  .container { max-width: 900px; margin: 20px auto; padding: 16px; background: var(--color-surface); border: 1px solid var(--color-border); border-radius: var(--radius-md); }
  h1 { font-size: 22px; margin-bottom: 12px; color: var(--color-text-primary); }
  h2 { font-size: 16px; margin: 16px 0 8px; color: var(--color-text-primary); }
  .content p { line-height: 1.7; color: var(--color-text-secondary); }
  .actions { margin-top: 20px; text-align: right; }
  .btn { padding: 8px 14px; background: var(--color-primary); color: #fff; border: 1px solid var(--color-primary); border-radius: var(--radius-sm); cursor: pointer; }
  .btn:hover { background: #0052a3; }
  </style>
